<template>
  <Bar :chartData="chartData" :chartOptions="chartOptions" />
</template>

<script setup>
import { Bar } from 'vue-chartjs'
import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  BarElement,
  CategoryScale,
  LinearScale,
} from 'chart.js'

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend)

defineProps({
  chartData: {
    type: Object,
    default() {
      return {
        labels: ['January', 'February', 'March'],
        datasets: [{ data: [40, 20, 12] }],
      }
    },
  },
  chartOptions: {
    type: Object,
    default() {
      return {
        plugins: {
          legend: {
            labels: {
              color: '#fff',
            },
          },
        },
        scales: {
          y: {
            beginAtZero: true,
          },
        },
      }
    },
  },
})
</script>
